import { render, staticRenderFns } from "./TransferFundsIntrabankPayeeList.vue?vue&type=template&id=7e6ec0c7"
import script from "./TransferFundsIntrabankPayeeList.vue?vue&type=script&lang=js"
export * from "./TransferFundsIntrabankPayeeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports